export default __webpack_public_path__ + "static/media/dole-juice-bg.a43c9305.png";